
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesReceiptGrid extends Serenity.EntityGrid<POSSalesReceiptRow, any> {
        protected getColumnsKey() { return 'Retail.POSSalesReceipt'; }
        protected getDialogType() { return POSSalesReceiptDialog; }
        protected getIdProperty() { return POSSalesReceiptRow.idProperty; }
        protected getInsertPermission() { return POSSalesReceiptRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesReceiptRow.localTextPrefix; }
        protected getService() { return POSSalesReceiptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}